(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ei-footer"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function setze() {
      document.querySelectorAll('.ei-footer__spalte').forEach(function (d) { d.open = !mq.matches; });
    }
    setze();
    mq.addEventListener('change', setze);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var liste = document.querySelector('.ei-trust');
    if (!liste || !window.matchMedia('(max-width: 599px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var timer = setInterval(function () {
      var breite = liste.clientWidth;
      if (!breite || document.hidden) return;
      var ziel = liste.scrollLeft + breite;
      liste.scrollTo({ left: ziel >= liste.scrollWidth - 4 ? 0 : ziel, behavior: 'smooth' });
    }, 3500);
    liste.addEventListener('pointerdown', function () { clearInterval(timer); }, { once: true });
    liste.addEventListener('touchstart', function () { clearInterval(timer); }, { once: true, passive: true });
  })();
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('.ei-weiterlesen__knopf');
    if (!knopf) return;
    var box = knopf.closest('[data-ei-weiterlesen]');
    var offen = box.classList.toggle('is-offen');
    knopf.setAttribute('aria-expanded', offen);
    knopf.textContent = offen ? 'Weniger anzeigen' : 'Weiterlesen';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elbeimker-category-bubbles"] && !Shopify.designMode) return;
  try {
    
  // Aktive Kategorie in den sichtbaren Bereich scrollen (nur wenn die Zeile überläuft)
  document.querySelectorAll('.eib__list').forEach((list) => {
    const current = list.querySelector('.is-current');
    if (!current || list.scrollWidth <= list.clientWidth) return;
    const item = current.closest('.eib__item') || current;
    const offset = item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
    list.scrollLeft = offset - (list.clientWidth - item.offsetWidth) / 2;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
